import React from 'react';

export default function PageHeader({ title, headerMeta, variant = 'dashboard' }) {
    if (variant === 'plain') {
        return <h1 className="page-header-plain">{title}</h1>;
    }
    return (
        <header className="dashboard-header">
            <h1>{title}</h1>
            {headerMeta != null && headerMeta !== '' && (
                <div className="dashboard-user-email">{headerMeta}</div>
            )}
        </header>
    );
}
